<template>
  <svg width="12" height="9" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.93572 3C2.93572 3.27335 3.04398 3.53551 3.23669 3.7288C3.4294 3.92209 3.69077 4.03067 3.9633 4.03067C4.23583 4.03067 4.4972 3.92209 4.68991 3.7288C4.88262 3.53551 4.99088 3.27335 4.99088 3C4.99088 2.72665 4.88262 2.46449 4.68991 2.2712C4.4972 2.07791 4.23583 1.96933 3.9633 1.96933C3.69077 1.96933 3.4294 2.07791 3.23669 2.2712C3.04398 2.46449 2.93572 2.72665 2.93572 3ZM7.94702 2.76258C7.07724 0.924847 5.76249 0 4 0C2.23659 0 0.922756 0.924847 0.0529804 2.7635C0.0180934 2.83759 0 2.91852 0 3.00046C0 3.0824 0.0180934 3.16333 0.0529804 3.23742C0.922756 5.07515 2.23751 6 4 6C5.7634 6 7.07724 5.07515 7.94702 3.2365C8.01766 3.08742 8.01766 2.91442 7.94702 2.76258ZM3.9633 4.61963C3.0715 4.61963 2.34853 3.89448 2.34853 3C2.34853 2.10552 3.0715 1.38037 3.9633 1.38037C4.85509 1.38037 5.57807 2.10552 5.57807 3C5.57807 3.89448 4.85509 4.61963 3.9633 4.61963Z"
      fill="#4CB5E2"
    />
  </svg>
</template>

<script>
export default {
  name: 'Viewing',
}
</script>

<style scoped></style>
